import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ManageTeachersNewController extends Controller {
  queryParams = ['schoolId']

  @tracked schoolId = ''
}
